import {Injectable, OnInit} from '@angular/core';
import {Http} from '@angular/http';
import {HttpClient, HttpHeaders, HttpParams} from '../../node_modules/@angular/common/http';
import {environment} from '../environments/environment';
import {map, share, shareReplay} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {resolve} from 'dns';
import {he} from 'cronstrue/dist/i18n/locales/he';
import CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class ConfService implements OnInit {
    pKeyHeader: any;
    adminPKeyHeader: any;
    httpOptions: any;
    httpOptionsOfThirdParty: any;
    adminHttpOptions: any;
    appclientHttpOptions: any;
    billingHttpOptions: any;
    templatesHttpOptions: any;
    commonsHttpOptions: any;
    AWSOptions: any;
    b2bOptions: any;
    monitoringOptions: any;
    file: any;
    captchaOptions: any;
    linkzyOptions: any;
    campaignOptions: any;
    getPartnerKeyOptions: any;
    servicesOptions: any;
    coreOptions: any;
    samplesOptions: any;
    partnerShortCode: any;
    environmentType: any;
    accessOptions: any;
    devAccessOptions: any;

    constructor(private _http: HttpClient, private http: Http) {
    }

    ngOnInit() {
    }

    getHttp() {

        if (localStorage.getItem('partner') !== undefined && localStorage.getItem('partner') !== null && localStorage.getItem('partner') !== '') {
            const partnerSplit = localStorage.getItem('partner').split('-');
            if (partnerSplit.length > 1) {
                this.partnerShortCode = partnerSplit[partnerSplit.length - 1];
                this.environmentType = partnerSplit[0];
            } else {
                this.partnerShortCode = localStorage.getItem('partner');
                this.environmentType = 'prod';
            }
        }

        this.pKeyHeader = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.adminPKeyHeader = new HttpHeaders({'pkey': environment.adminPkey});


        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.httpOptionsOfThirdParty = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.thirdPartyPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.adminHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.adminPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.getPartnerKeyOptions = {

            headers: new HttpHeaders({
                'pkey': environment.adminPkey
            })
        };

        this.appclientHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.appclientPkey,
                'x-api-key': environment.appclientAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.b2bOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.b2bPKey,
                'x-api-key': environment.b2bAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.billingHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.billingPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.templatesHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.templatesPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.commonsHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.commonsPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.AWSOptions = {

            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-api-key': environment.AWSAPIKey
            })
        };

        this.captchaOptions = {

            headers: new HttpHeaders({
                'apikey': environment.captchaAPIKey,
                'pkey': environment.captchaPkey,
                // 'Content-Type': 'application/json',
                // 'pkey': '3fe408b3a9da46563fecb834832ef39d',
                // 'Access-Control-Allow-Origin': '*',
                // 'observe': 'response'

            })
        };

        this.linkzyOptions = {

            headers: new HttpHeaders({
                'apikey': 'DPsm13YUiwG7ied906pmR2qWNCJCvrHY',
                'pkey': '3fdfb5476cd996603febe74f67d39715',
                // 'Content-Type': 'application/json',
                // 'pkey': '3fe408b3a9da46563fecb834832ef39d',
                // 'Access-Control-Allow-Origin': '*',
                // 'observe': 'response'

            })
        };

        this.campaignOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.campaignPkey,
                'apikey': environment.campaignAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.servicesOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.servicesPkey,
                'apikey': environment.servicesAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.coreOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.corePkey,
                'apikey': environment.coreAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.monitoringOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.monitoringPkey,
                'apikey': environment.monitoringAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.samplesOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.samplesPkey,
                'apikey': environment.samplesAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.accessOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.accessPkey,
                'apikey': environment.accessAPIKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.devAccessOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.devAccessPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
    }

    createHmacHeaders(
        method: string,
        requestUri: string,
        hmacParams: { hmac_headers: string[]; secret: string, username: string, algorithm: string },
        payload
    ) {
        const timestamp = new Date().toUTCString();
        const jsonString = JSON.stringify(payload);
        const sha256Digest = CryptoJS.SHA256(jsonString).toString(
            CryptoJS.enc.Base64
        );
        const digestHeader = `SHA-256=${sha256Digest}`;

        const headers: Record<string, string> = {
            'x-date': timestamp,
            digest: digestHeader,
        };
        let signingString = '';
        const hmacHeaders = hmacParams.hmac_headers;

        for (const header of hmacHeaders) {
            const headerValue = headers[header];
            if (!headerValue) {
                if (header === '@request-target') {
                    const requestTarget = `${method} ${requestUri}`;
                    signingString += `${header}: ${requestTarget}`;
                } else if (header === 'request-line') {
                    const requestLine = `${method} ${requestUri} HTTP/1.1`;
                    signingString += requestLine;
                } else {
                    signingString += `${header}:`;
                }
            } else {
                signingString += `${header}: ${headerValue}`;
            }

            if (hmacHeaders.indexOf(header) < hmacHeaders.length - 1) {
                signingString += '\n';
            }
        }
        const hmacSignature = CryptoJS.HmacSHA256(signingString, hmacParams.secret).toString(
            CryptoJS.enc.Base64);

        const authHeader = `hmac username="${hmacParams.username}", algorithm="hmac-sha256", headers="x-date digest", signature="${hmacSignature}"`;
        return {
            Authorization: authHeader,
            digest: digestHeader,
            'x-date': timestamp
        };
    }

    uploadXMLToCamunda(partner, account, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/camunda/deployment/create', data, this.httpOptions)
            .pipe(map(res => res));

    }

    getPartnerOnboard() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/partners', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    isPartnerAlreadyExist(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/exists', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    checkPartnerShortcodeExistence(payload) {
        this.getHttp();
        // return this._http.post(environment.serviceshost + '/v2/partner-shortcode-existence', payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.post(environment.apihost + '/services/services/v2/partner-shortcode-existence', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    notifyErrorToAdmins(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/services/services/v1/notify-admin', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    sendEngagementMailDuringOnboarding(payload) {
        this.getHttp();
        // return this._http.post(environment.serviceshost + '/v1/partnerOnboardingEngagement', payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.post(environment.apihost + '/services/services/v1/partnerOnboardingEngagement', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    insertPartner(data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/partners', JSON.stringify(data), this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getPartnerDirectly(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getCaptchaSiteKey() {
        this.getHttp();
        return this._http.get(environment.konghost + '/v1/billings/billings/recaptcha?query=key:googlerecaptcha', this.captchaOptions)
            .pipe(map(res => res));
    }

    getIndustryType() {
        this.getHttp();
        return this._http.get('https://' + environment.linkzyHost + '/v1/industrytype', this.linkzyOptions)
            .pipe(map(res => res));
    }

    createRoute53S3Bucket(data) {
        // this.getHttp();
        return this._http.post('https://k9xc4vfch9.execute-api.us-east-1.amazonaws.com/default/route53DNS-s3bucket', JSON.stringify(data), {
            headers: new HttpHeaders().set('x-api-key', 'DBnsIEzlsP7uqEA3C1bjn2ael5BtYRH2atjDA1A3'),
        });
    }

    SNSVerification(data) {
        // this.getHttp();
        return this._http.post('https://k9xc4vfch9.execute-api.us-east-1.amazonaws.com/default/onboardingSNS', JSON.stringify(data), {
            headers: new HttpHeaders().set('x-api-key', 'DBnsIEzlsP7uqEA3C1bjn2ael5BtYRH2atjDA1A3'),
        });
    }

    payment(data) {
        return this._http.post('https://dlk36i9i24.execute-api.us-east-1.amazonaws.com/default/paymentGateway', JSON.stringify(data), {
            headers: new HttpHeaders().set('x-api-key', 'DqQ1thAfu3aF9mBKlxo1S4q3KBzhzSWp2czdc46M')
        });
    }

    createAppClientIdForPartner(data) {
        this.getHttp();
        return this._http.post(environment.iamhost + '/v1/client', JSON.stringify(data), this.appclientHttpOptions)
            .pipe(map(res => res));
    }

    getAppClientDetailsForPartner(data) {
        this.getHttp();
        return this._http.post(environment.iamhost + '/v1/client/describe', JSON.stringify(data), this.appclientHttpOptions)
            .pipe(map(res => res));
    }

    registerIdentityProvider(data) {
        this.getHttp();
        return this._http.post(environment.iamhost + '/v1/identityprovider', JSON.stringify(data), this.appclientHttpOptions)
            .pipe(map(res => res));
    }

    registerIdentityProviderWithUrl(name, type, url) {
        this.getHttp();
        return this._http.post(environment.iamhost + '/v1/identityprovider?providerName=' + name + '&providerType=' + type + '&metadataUrl=' + url, this.appclientHttpOptions)
            .pipe(map(res => res));
    }

    updateAppClientSettings(data) {
        this.getHttp();
        return this._http.put(environment.iamhost + '/v1/client', JSON.stringify(data), this.appclientHttpOptions)
            .pipe(map(res => res));
    }

    getPartner(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/myaccount', this.httpOptions)
            .pipe(map(res => res));
    }

    getPartnerWithPkey(partner, account, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/myaccount', {headers: headers})
            .pipe(map(res => res));
    }

    deleteInfra(payload) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: payload
        };
        return this._http.delete(environment.pythonServicesServer + '/v1/admin/infra/delete', options)
            .pipe(map(res => res));
    }

    disableInfra(payload) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: payload
        };
        return this._http.delete(environment.pythonServicesServer + '/v1/admin/infra/delete', options)
            .pipe(map(res => res));
    }

    // getPartner(id) {
    //     return this.http.get(environment.apihost + '/v1/admin/' + id)
    //         .pipe(map(res => res.json()));
    // }

    getPartnerByName(id) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + id, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    createPartner(payload) {
        const headersWithHmac = this.createHmacHeaders('POST', '/v1/partner/create', {
            username: environment.accountsHmacUsername,
            algorithm: 'hmac-sha256',
            hmac_headers: ['x-date', 'digest'],
            secret: environment.accountsHmacSecret
        }, payload);
        headersWithHmac['Content-Type'] = 'application/json';
        headersWithHmac['Access-Control-Allow-Origin'] = '*';
        const headers = new HttpHeaders(headersWithHmac);
        this.getHttp();
        return this._http.post(environment.accountsHost + '/v1/partner/create', payload, {headers: headers})
            .pipe(map(res => res));
    }

    completeApiJoinsRequest(payload) {
        const headersWithHmac = this.createHmacHeaders('POST', '/v1/complete-apijoins-request', {
            username: environment.coreHmacUsername,
            algorithm: 'hmac-sha256',
            hmac_headers: ['x-date', 'digest'],
            secret: environment.coreHmacSecret
        }, payload);
        headersWithHmac['Content-Type'] = 'application/json';
        headersWithHmac['Access-Control-Allow-Origin'] = '*';
        const headers = new HttpHeaders(headersWithHmac);
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/complete-apijoins-request', payload, {headers: headers})
            .pipe(map(res => res));
    }

    deletePartnerByName(id) {
        this.getHttp();
        return this._http.delete(environment.apihost + '/v1/admin/' + id, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    deleteEnvironment(params) {
        this.getHttp();
        return this._http.delete(environment.apihost + '/services/services/v1/deletePartnerEnvironment?' + params, this.servicesOptions)
            .pipe(map(res => res));
    }

    validatePartnerEmailWithShortCode(partner, email) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/validate-email/' + email, {
            headers: this.adminPKeyHeader,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    isValidPartner(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/isvalidpartner', {
            headers: this.adminPKeyHeader,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    getOperations(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + 'operations', this.httpOptions)
            .pipe(map(res => res));
    }

    updatePartner(data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/partners', JSON.stringify(data), this.adminHttpOptions)
            .pipe(map(res => res));
    }

    updateDatabase(data, partnerId) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partnerId + '/databases/bulkupdate', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateAdfsConfiguration(data, partnerId) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partnerId + '/adfsconfig/update', data, this.httpOptions)
            .pipe(map(res => res));
    }

    createCollection(collections) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/database/' + collections.partner + '/' + collections.account + '/' + collections.entity + '/create', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    // validateLogin(email, password, partner) {
    //     this.getHttp();
    //     return this._http.get(environment.apihost + '/v1/login?password=' + password + '&username=' + email + '&partner=' + partner, {observe: 'response'})
    //         .pipe(map(response => response));
    // }
    validateLogin(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/login', payload, {observe: 'response'})
            .pipe(map(response => response));
    }

    getUserDetailsOnSuccessfulLogin(partner, account) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/category/entities', {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    createJWTToken(partner, account, pkey, payload) {
        this.getHttp();
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/auth/jwt/create-token', payload, {
            observe: 'response',
            headers: headers,
            responseType: 'text'
        })
            .pipe(map(res => res));
    }

    parseJWTToken(partner, account, pkey, payload) {
        this.getHttp();
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/auth/jwt/parse-token', payload, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    getProcessIdFromCamunda(partner, account, fabResult) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/camunda/getdeploymentid', fabResult, this.httpOptions)
            .pipe(map(res => res));
    }

    registerEmail(email) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/registration/verifyEmail?emailId=' + email, {observe: 'response'})
            .pipe(map(res => res));
    }

    // resendEmail(email, token) {
    //     this.getHttp();
    //     return this._http.get(environment.apihost + '/v1/registration/resendEmail?emailId=' + email + '&token=' + token, {observe: 'response'})
    //         .pipe(map(res => res));
    // }

    resetEmail(email) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/resetpassword?emailId=' + email, this.httpOptions)
            .pipe(map(res => res));
    }

    getPlans() {
        const headers = new HttpHeaders({
            pkey: '3fee0e37fef58a553fddddb61efd53e4',
            'Access-Control-Allow-Origin': '*',
        });
        return this._http.get(environment.apihost + '/v1/admin/billing/billing/Plans/IN/plans', this.billingHttpOptions).pipe(map(res => res));
    }

    getPlansFeatures() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/billing/billing/Features/plans/features', this.billingHttpOptions)
            .pipe(map(res => res));
    }

    passwordComplete(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/resetpassword/complete', payload, {responseType: 'text'})
            .pipe(map(res => res));
    }

    verifyToken(email, token) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/signup?emailId=' + email + '&token=' + token, {observe: 'response'})
            .pipe(map(res => res));
    }

    updateOnboardingToken(email, token) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/updateOnboardingToken?emailId=' + email + '&token=' + token, {observe: 'response'})
            .pipe(map(res => res));
    }

    resendVerificationEmail(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/registration/resendEmail', payload)
            .pipe(map(res => res));
    }

    getSubscribedExecutors(partner, account, params) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/producer/executors?producer=' + params, this.b2bOptions)
            .pipe(map(res => res));
    }

    getMyProviderExecutors(partner, account, params) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/producer/executors?producer=' + params, this.httpOptions)
            .pipe(map(res => res));
    }

    getB2bExecutors() {
        this.getHttp();
        return this._http.get(environment.serviceshost + '/v1/apiproducers', this.servicesOptions)
            .pipe(map(res => res));
    }

    letsTalk(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/letsTalk', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    verifyResetToken(email, token, environmentsString) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/resetpassword/confirm?emailId=' + email + '&token=' + token + '&environmentsString=' + environmentsString, {observe: 'response'})
            .pipe(map(res => res));
    }

    getCustomOperation(partner, account, operation) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/operations/' + operation, this.httpOptions)
            .pipe(map(res => res));
    }

    getEntitiesForPartnerAccount(partner, account) {
        this.getHttp();
        if (partner === 'commons') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', this.commonsHttpOptions)
                .pipe(map(res => res));
        }
        if (partner === 'templates') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', this.templatesHttpOptions)
                .pipe(map(res => res));
        }
        if (partner === 'samples') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', this.samplesOptions)
                .pipe(map(res => res));
        }
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', this.httpOptions)
            .pipe(map(res => res));
    }

    getEntity(partner, account, entity, version) {
        this.getHttp();
        if (partner === 'commons') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, this.commonsHttpOptions)
                .pipe(map(res => res));
        } else if (partner === 'templates') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, this.templatesHttpOptions)
                .pipe(map(res => res));
        } else if (partner === 'samples') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, this.samplesOptions)
                .pipe(map(res => res));
        } else if (partner === 'services') {
            this.getHttp();
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, this.servicesOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, this.httpOptions)
                .pipe(map(res => res));
        }
    }

    getEntityForPartner(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, {headers: headers})
            .pipe(map(res => res));
    }

    getDatabaseTables(partner, database, databaseType) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + database + '/get-database-tables', this.httpOptions)
            .pipe(map(res => res));
    }

    checkIfTableExists(partner, tableName, database, databaseType) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database-table/exists?table=' + tableName + '&database=' + database + '&databaseType=' + databaseType, this.httpOptions)
            .pipe(map(res => res));
    }

    checkIfTableExistsForpartner(partner, pkey, tableName, database, databaseType) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database-table/exists?table=' + tableName + '&database=' + database + '&databaseType=' + databaseType, {headers: headers})
            .pipe(map(res => res));
    }

    getDefaultAPIResponse(partner, account, method) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/get-default-api-response?method=' + method, this.httpOptions)
            .pipe(map(res => res));
    }

    getTableAttributes(partner, tableName, database, databaseType) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/table-attributes?table=' + tableName + '&database=' + database + '&databaseType=' + databaseType, this.httpOptions)
            .pipe(map(res => res));
    }

    deleteDataForAnEntity(partner, account, pkey, entity, version, params) {
        let url = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity;
        if (params && params !== '') {
            url = url + '?' + params;
        }
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.delete(url, {headers: headers});
    }

    deleteCollectionByPartnerAccountEntityVersion(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.delete(environment.apihost + '/v1/collection/' + partner + '/' + account + '/' + entity + '/' + version, {
            headers: headers,
            observe: 'response',
            responseType: 'text'
        })
            .pipe(map(res => res));
    }

    removeCollectionFromSequences(partner, account, entity, version) {
        return this._http.delete(environment.apihost + '/' + version + '/sequence/' + partner + '/' + account + '/' + entity, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    deleteEntity(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.delete(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version, {headers: headers})
            .pipe(map(res => res));
    }

    deleteAPIPermissions(partner, account, APIName, version) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'Access-Control-Allow-Origin': '*',
        });
        return this._http.delete(environment.serviceshost + '/v1/deleteApiPermissions?partner=' + partner + '&account=' + account + '&entityName=' + APIName + '&entityVersion=' + version, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    updateApiStatusToPartnerAccountEntityInDashboard(partner, account, entity, version, status) {
        this.getHttp();
        // const headers = new HttpHeaders({
        //     'Content-Type': 'application/json',
        //     'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
        //     'Access-Control-Allow-Origin': '*',
        //     'observe': 'response'
        // });
        return this._http.put(environment.apihost + '/' + version + '/admin/' + partner + '/' + account + '/' + entity + '/api/status?status=' + status, '', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    updateGateway(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayService(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/service', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayRoutes(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/routes', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayKeyAuth(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/keyauth', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayACL(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/acl', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayCors(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/cors', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayBotDetection(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/botdetection', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayIpRestriction(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/iprestriction', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayRateLimiting(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/ratelimiting', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayRequestSizeLimiting(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/requestsizelimiting', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updateGatewayRequestTermination(partner, account, entity, version, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/gateway/requesttermination', data, this.httpOptions)
            .pipe(map(res => res));
    }

    updatePartnerAccount(partner, account, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account, JSON.stringify(data), this.httpOptions)
            .pipe(map(res => res));
    }

    insertEntity(partner, account, data) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account, JSON.stringify(data), {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    insertEntityForPartner(partner, account, pkey, data) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account, JSON.stringify(data), {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    updateEntity(partner, account, data) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', data, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    updateEntityWithPkey(partner, account, data, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities', data, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    patchEntity(partner, account, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities?replaceAll=false', data, this.httpOptions)
            .pipe(map(res => res));
    }

    bulkUpdateDatabases(partner, databases) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/databases/bulkupdate', databases, this.httpOptions)
            .pipe(map(res => res));
    }

    patchEntityData(partner, account, version, entity, id, data) {
        this.getHttp();
        if (partner === 'services') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, data, this.servicesOptions)
                .pipe(map(res => res));
        } else if (partner === 'access') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, data, this.accessOptions)
                .pipe(map(res => res));
        } else if (partner === 'dev-access') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, data, this.devAccessOptions)
                .pipe(map(res => res));
        }
    }

    getCategoriesForPartner(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/categories', this.httpOptions)
            .pipe(map(res => res));
    }

    getCommonApisForPartner() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/commons/commons/marketplace/entities', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    getLanguages() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/commons/commons/languages', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    getDataTypes() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/commons/commons/data-types', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    getPartnerSettings(partner, account, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/core/core/v1/partner-settings', {headers: headers})
            .pipe(map(res => res));
    }

    getAdvancedPartnerSettings(partner, account, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            // 'API-PLATFORM-PARTNER-KEY': pkey,
            // 'API-PLATFORM-PARTNER': partner,
            // 'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/core/core/v1/partner-settings-adv?partner=' + partner + '&account=' + account, {headers: headers})
            .pipe(map(res => res));
    }

    manageApiGateways(partner, account, pkey, action, payload) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            // 'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        return this._http.post(environment.coreHost + '/v1/api-gateway', {action: action, config: payload}, {headers: headers})
            .pipe(map(res => res));
    }

    getSettingsV2CRUD(partner, account, dbref) {
        let url = '';
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        if (!dbref) {
            url = environment.apihost + '/v2/data/services/services/settings?partner=' + partner + '&account=' + account + '&dbref=false';
        } else {
            url = environment.apihost + '/v2/data/services/services/settings?partner=' + partner + '&account=' + account;
        }
        return this._http.get(url, {observe: 'response', headers: servicesOptions})
            .pipe(map(res => res));
    }

    getAppConfigs(partner) {
        const headersWithHmac = this.createHmacHeaders('POST', '/v1/app-configs', {
            username: environment.coreHmacUsername,
            algorithm: 'hmac-sha256',
            hmac_headers: ['x-date', 'digest'],
            secret: environment.coreHmacSecret
        }, '');
        headersWithHmac['Content-Type'] = 'application/json';
        headersWithHmac['Access-Control-Allow-Origin'] = '*';
        const headers = new HttpHeaders(headersWithHmac);
        this.getHttp();
        return this._http.get(environment.coreHost + '/v1/app-config?partner=' + partner, {headers: headers})
            .pipe(map(res => res));
    }

    getSettingsV2(query) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v2/data/services/services/settings?' + query, this.servicesOptions);
    }

    saveExecutorInformation(version, payload) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/' + version + '/data/services/services/apiHistory', payload, {
            observe: 'response',
            headers: servicesOptions
        })
            .pipe(map(res => res));
    }

    getPlatformData(version, api, params) {
        let url = '';
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });

        url = environment.serviceshost + '/' + version + '/' + api;
        return this._http.get(url, {observe: 'response', headers: servicesOptions, params: params})
            .pipe(map(res => res));
    }

    getLearningVideos(params) {
        let url = '';
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });

        url = environment.serviceshost + '/v1/learningvideos';
        return this._http.get(url, {observe: 'response', headers: servicesOptions, params: params})
            .pipe(map(res => res));
    }

    getCountryCodes() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/commons/commons/country-master', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    getDatabaseObjectTypes() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/commons/commons/database-object-types', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    getCloudRegions() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/commons/commons/cloud-regions', this.commonsHttpOptions)
            .pipe(map(res => res));
    }

    postFeedback(data, version, entity) {
        return this._http.post(environment.serviceshost + '/' + version + '/' + entity, data, this.servicesOptions)
            .pipe(map(res => res));
    }

    sendFeedback(data) {
        return this._http.post(environment.apihost + '/v1/admin' + '/feedback/send', data)
            .pipe(map(res => res));
    }

    sendSalesQuery(data) {
        return this._http.post(environment.apihost + '/v1/admin' + '/sales/send', data)
            .pipe(map(res => res));
    }

    getBusinessTemplatesForPartner() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/templates/templates/dashboard/category/entities', this.templatesHttpOptions)
            .pipe(map(res => res));
    }

    // getApiVersionsForPartnerAccount(partner, account) {
    //     this.getHttp();
    //     return this._http.get<EntityVersions[]>(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entity/versions', this.httpOptions)
    //         .pipe(map(res => res));
    // }

    getEntityCountForPartnerAccount(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entities/count', this.httpOptions)
            .pipe(map(res => res));
    }

    getEntityCountForPartner(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + '/entities/count', this.httpOptions)
            .pipe(map(res => res));
    }

    getPartnerKey(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/pkey', this.getPartnerKeyOptions)
            .pipe(map(res => res));
    }

    getCategoriesEntitiesForPartner(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/dashboard/category/entities', this.httpOptions)
            .pipe(map(res => res));
    }

    refreshBillingForPartnerAccount(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/refresh/billing', this.httpOptions)
            .pipe(map(res => res));
    }

    getFAQ() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/confap/legaldocuments?doc=title:FAQ', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getTermsAndConditions() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/confap/legaldocuments?doc=title:Cloud Terms of Service', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getLegalDocs(val) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/confap/legaldocuments?doc=' + val, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getPrivacyPolicy() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/confap/legaldocuments?doc=title:Privacy Policy', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    insertAccount(partnerId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/accounts', data, this.httpOptions)
            .pipe(map(res => res));
    }

    insertDatabase(partnerId, data) {
        this.getHttp();
        let headers: any;
        headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        let partnerEnvType = '';
        const partnerSplit = partnerId.split('-');
        if (partnerSplit.length > 1) {
            partnerEnvType = partnerSplit[0];
        } else {
            partnerEnvType = 'prod';
        }
        if (this.environmentType === 'admin' && partnerEnvType !== 'admin') {
            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response',
                'environment': partnerId
            });
            partnerId = 'admin-' + this.partnerShortCode;
        }
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/databases', data, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    testConnectionDatabase(data) {
        // this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/database/test', data, {observe: 'response'})
            .pipe(map(res => res));
    }

    getDatabases(partnerId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/databases', this.httpOptions)
            .pipe(map(res => res));
    }

    authorizePartner(partner, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/authorize', {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    getDatabasesForPartner(partnerId, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/databases', {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    getDatabaseForPartner(partnerId, accountId, database) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/databases/' + database, this.httpOptions)
            .pipe(map(res => res));
    }

    getDatabaseForPartnerWithPkey(partnerId, accountId, database, pkey) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/databases/' + database, {headers: headers})
            .pipe(map(res => res));
    }

    addDatabase(partnerId, payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/add-database', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    getAdfsConfigs(partnerId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/adfsconfigs', this.httpOptions)
            .pipe(map(res => res));
    }

    deleteAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.delete(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId, this.httpOptions)
            .pipe(map(res => res));
    }

    getCloudWatchMetricsTrend(partnerId, accountId, entity, version) {
        this.getHttp();
        return this._http.get(this.getUrlForApiMetricsHitsWeeklyTrend(partnerId, accountId, entity, version), this.httpOptions)
            .pipe(map(res => res));
    }

    getCloudWatchMetricsLatencyTrend(partnerId, accountId, entity, version) {
        this.getHttp();
        return this._http.get(this.getUrlForApiMetricsLatencyWeeklyTrend(partnerId, accountId, entity, version), this.httpOptions)
            .pipe(map(res => res));
    }

    getUrlForApiMetricsHitsWeeklyTrend(partnerId, accountId, entity, version) {

        return environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/cloudwatch/' + partnerId + '_' + accountId + '_' + entity + '_' + version + '_totalRequest_count' + '/Sum?frequency=1%20h&namespace=CWAgent&offset=1%20w&requestedMetric=totalRequest_count';
    }

    getUrlForApiMetricsLatencyWeeklyTrend(partnerId, accountId, entity, version) {

        return environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/cloudwatch/' + partnerId + '_' + accountId + '_' + entity + '_' + version + '_latency' + '/Average?frequency=1%20h&namespace=CWAgent&offset=1%20w&requestedMetric=latency';
    }

    // getCloudWatchMetrics(partnerId, accountId) {
    //     this.getHttp();
    //
    //     return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/cloudwatch/metrics/Sum?namespace=CWAgent&offset=1%20w&requestedMetric=totalRequest_count', this.httpOptions)
    //         .pipe(map(res => res));
    // }
    //
    // getCloudWatchLatencyMetrics(partnerId, accountId) {
    //     this.getHttp();
    //
    //     return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/cloudwatch/metrics/Average?namespace=CWAgent&offset=1%20w&requestedMetric=latency', this.httpOptions)
    //         .pipe(map(res => res));
    // }

    deleteDatabase(partnerId, database_name) {
        this.getHttp();
        let headers: any;
        headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        let partnerEnvType = '';
        const partnerSplit = partnerId.split('-');
        if (partnerSplit.length > 1) {
            partnerEnvType = partnerSplit[0];
        } else {
            partnerEnvType = 'prod';
        }
        if (this.environmentType === 'admin' && partnerEnvType !== 'admin') {
            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response',
                'environment': partnerId
            });
            partnerId = 'admin-' + this.partnerShortCode;
        }
        return this._http.delete(environment.apihost + '/v1/admin/' + partnerId + '/databases/' + database_name, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    updateDatabaseConnection(partnerId, database_name, payload) {
        this.getHttp();
        let headers: any;
        headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        let partnerEnvType = '';
        const partnerSplit = partnerId.split('-');
        if (partnerSplit.length > 1) {
            partnerEnvType = partnerSplit[0];
        } else {
            partnerEnvType = 'prod';
        }
        if (this.environmentType === 'admin' && partnerEnvType !== 'admin') {
            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response',
                'environment': partnerId
            });
            partnerId = 'admin-' + this.partnerShortCode;
        }
        return this._http.put(environment.apihost + '/v1/admin/' + partnerId + '/databases/' + database_name, payload, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    createAPI(partnerId, accountId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/createfromapi', data, this.httpOptions)
            .pipe(map(res => res));
    }

    createAPIFromDB(partnerId, accountId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/createfromdatabase', data, this.httpOptions)
            .pipe(map(res => res));
    }

    createAPIByDBObjects(partnerId, accountId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/createfromdatabasetable', data, this.httpOptions)
            .pipe(map(res => res));
    }

    createAPIFromYaml(partnerId, accountId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/createfromyaml', data, this.httpOptions)
            .pipe(map(res => res));
    }

    getPartnerEntity(account, entity, partner) {
        this.getHttp();
        if (partner === 'services') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity, this.servicesOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity, this.httpOptions)
                .pipe(map(res => res));
        }
    }

    updateIPWhitelist(partner, data) {
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/' + partner + '/ipwhitelist?replaceAll=true', data, this.httpOptions)
            .pipe(map(res => res));
    }

    getS3Files(partner) {
        this.getHttp();
        /*return this._http.get(environment.apihost + '/v1/data/' + partner + '/' +partner + '/s3connectors/' + partner + '.apiplatform.io' + '/list-files', this.httpOptions)
            .pipe(map(res => res));*/
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/files/meta-data', {}, this.httpOptions)
            .pipe(map(res => res));
    }


    createFolderInS3(partner, directory) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey')
            })
        };
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/folder?folder=' + directory, {}, {
            observe: 'response',
            headers: httpOptions.headers
        })
            .pipe(map(res => res));
    }

    uploadFolderInS3(partner, file: File, directory, fileName) {
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', file, fileName);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey')
            })
        };
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/file?folder=' + directory, formData, {
            observe: 'response',
            headers: httpOptions.headers
        })
            .pipe(map(res => res));
    }

    uploadFileInS3(partner, file: File, directory) {
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', file);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey')
            })
        };
        if (directory != '') {
            return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io/file?folder=' + directory, formData, {
                observe: 'response',
                headers: httpOptions.headers
            })
                .pipe(map(res => res));
        } else {
            return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io/file', formData, {
                observe: 'response',
                headers: httpOptions.headers
            })
                .pipe(map(res => res));
        }
    }

    deleteFileFromS3Bucket(partner, fileName) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey')
            })
        };
        return this._http.delete(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/file?fileName=' + fileName, {
            observe: 'response',
            headers: httpOptions.headers
        })
            .pipe(map(res => res));
    }

    deleteFolderFromS3Bucket(partner, folder) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey')
            })
        };
        return this._http.delete(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/folder?folder=' + folder, {
            observe: 'response',
            headers: httpOptions.headers
        })
            .pipe(map(res => res));
    }

    getS3bucketFiles(partner, directory, isFilesOnly) {
        const httpoptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response',
            }),
            params: {
                'folder': directory,
                'isFilesOnly': isFilesOnly
            }
        };

        return this._http.get(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/list-files', httpoptions)
            .pipe(map(res => res));
    }

    deleteFile(fileName, folder, partner) {
        this.getHttp();
        return this._http.delete(environment.apihost + '/v1/data/' + partner + '/delete/s3/file?fileName=' + fileName + '&folder=' + folder, this.httpOptions)
            .pipe(map(res => res));
    }

    uploadToS3Bucket(fileName, partner, image: File, folder, bucketName) {
        // this.getHttp();
        // const formData = new FormData();
        // formData.append('multipartFile', image);
        // const httpOptions = {
        //     headers: new HttpHeaders({
        //         'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
        //         'Access-Control-Allow-Origin': '*',
        //         'Content-Type': 'multipart/form-data'
        //     })
        // };
        // return this._http.post(environment.apihost + '/v1/data/' + partner + '/s3Connectors/' + bucketName + '/file?' + (fileName ? 'fileName=' + fileName : '') + '&' +
        //     (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp));
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', image);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            })
        };
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/upload?' + (fileName ? 'fileName=' + fileName : '') + '&' +
            (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp.toString()));
    }

    uploadS3File(fileName, partner, image: File, folder) {
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', image);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey'),
            })
        };
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/upload?' + (fileName ? 'fileName=' + fileName : '') + '&' +
            (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp.toString()));
    }

    uploadS3FileForResume(account, fileName, partner, image: File, folder) {
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', image);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey'),
            })
        };
        folder = 'resumes%2Ftraining_resumes';
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + account + '/uploadfiletopartneraccount?' + (fileName ? 'fileName=' + fileName : '') + '&' +
            (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp));
    }

    uploadS3FileForBPMN(account, fileName, partner, image: File, folder) {
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', image);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey'),
            })
        };
        // folder = 'bpmn%2FBPMNfiles';
        folder = folder;
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + account + '/uploadfiletopartneraccount?' + (fileName ? 'fileName=' + fileName : '') + '&' +
            (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp));
    }

    extractDataFromResume(partner, data, pkey) {
        let sendData = {};
        sendData['accountId'] = partner;
        sendData['bucketName'] = partner;
        sendData['pkey'] = pkey;
        sendData['binaryModelPath'] = 'resumes/binary_model';
        const temp = [];
        temp.push(data['s3URL']);
        sendData['resumes'] = temp;
        return this._http.post(environment.deepLearningServer + '/v2/resume/extractData', JSON.stringify(sendData));
    }

    trainDataForResume(partner, data, pkey) {
        return this._http.post(environment.deepLearningServer + '/v2/resume/trainModel', JSON.stringify(data));
    }

    createAnnotateFileInS3(partner, data, s3URL) {
        let sendData = {};
        sendData['partner'] = partner;
        sendData['response'] = data;
        sendData['s3URL'] = s3URL;
        sendData['accessKey'] = 'AKIAJYWAYWV6J4VPXDTA';
        sendData['secretKey'] = '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';
        sendData['bucketName'] = partner;
        sendData['binaryModelFolderPath'] = 'resumes/v2/binaryModel';
        return this._http.post(environment.deepLearningServer + '/v2/resume/annotateData', JSON.stringify(sendData));
    }

    getAWSCredentilasForPartner(partner, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/' + partner + '/' + accountId + '/awscredentials', this.httpOptions)
            .pipe(map(res => res));
    }

    getMaxAPILimit(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/maxapis', this.httpOptions)
            .pipe(map(res => res));
    }

    getAttributesForQueryBuilder(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/attributes', this.httpOptions)
            .pipe(map(res => res));
    }

    insertCustomOperation(partnerId, accountId, data) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/operation', data, this.httpOptions)
            .pipe(map(res => res));
    }

    // getDashboardMetrics(partner, account) {
    //     const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'})};
    //     return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/dashboard/metrics', httpOptions)
    //         .pipe(map(res => res));
    // }

    // getCategoriesForPartner(partner, account): Observable<Promise<any[]>> {
    //     const httpOptions = { headers: new HttpHeaders({'Content-Type':  'application/json', 'Access-Control-Allow-Origin': '*'})};
    //     return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/categories', httpOptions)
    //         .pipe(map(this.extractData));
    // }
    // extractData( response : Response){
    //     let body = response.json();
    //     return body;
    // }


    // /*insertEntity(partner, account, data) {
    //     const httpOptions = { headers: new HttpHeaders({'Content-Type':  'application/json', 'Access-Control-Allow-Origin': '*'})};
    //     return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account, JSON.stringify(data), httpOptions)
    //         .pipe(map(res => res ));
    // }*/


    // Executor APIS

    getApiExecutorsForPartnerAccount(partnerId, accountId) {
        this.getHttp();
        switch (partnerId) {
            case 'samples':
                return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/category/executors', this.samplesOptions)
                    .pipe(map(res => res));
                break;
            default:
                return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/category/executors', this.httpOptions)
                    .pipe(map(res => res));
                break;
        }
    }

    getBusinessLogicApisByCategoryForPartnerAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/category/businesslogicapis', this.httpOptions)
            .pipe(map(res => res));
    }

    getThirdPartyApisByCategoryForPartnerAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/list/THIRDPARTY', this.httpOptions)
            .pipe(map(res => res));
    }

    getApiExecutorsByPartnerAccountCategory(partner, account, category) {
        this.getHttp();
        if (partner === 'b2b') {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + category + '/executors', this.b2bOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + category + '/executors', this.httpOptions)
                .pipe(map(res => res));
        }
    }

    getPartnerAccountServiceProviderCategorybyGroup(partner, account, provider) {
        this.getHttp();
        if (partner === 'b2b') {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/producer/' + provider + '/executors', this.b2bOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/producer/' + provider + '/executors', this.httpOptions)
                .pipe(map(res => res));
        }
    }

    getThirdPartyApisByCategoryForPartnerAccountbyParams(partnerId, accountId, params) {
        this.getHttp();
        if (partnerId === 'b2b') {
            return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/list/THIRDPARTY?' + params, this.b2bOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/list/THIRDPARTY?' + params, this.httpOptions)
                .pipe(map(res => res));
        }
    }

    getSqlQueryApisByCategoryForPartnerAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/list/SQLQUERY', this.httpOptions)
            .pipe(map(res => res));
    }

    getWorkflowApisByCategoryForPartnerAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/list/WORKFLOW', this.httpOptions)
            .pipe(map(res => res));
    }

    getApiExecutorsForThirdPartnerAccount(partnerId, accountId) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partnerId + '/' + accountId + '/category/executors', this.httpOptionsOfThirdParty)
            .pipe(map(res => res));
    }

    getApiExecutorsByPartnerAccountEntityVersion(partner, account, entity, version) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executors', this.httpOptions)
            .pipe(map(res => res));
    }

    getApiExecutorByPartnerAccountEntityVersion(partner, account, entity, version) {
        this.getHttp();
        if (partner === 'services') {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executor', this.servicesOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executor', this.httpOptions)
                .pipe(map(res => res));
        }

    }

    getApiExecutorByPartnerAccountByNameAndVersion(partner, account, entity, version) {
        this.getHttp();
        switch (partner) {
            case 'samples':
                return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executor', this.samplesOptions)
                    .pipe(map(res => res));
                break;
            default:
                return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executor', this.httpOptions)
                    .pipe(map(res => res));
                break;
        }
    }

    getAPIExecutorForPartnerAccount(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executor', {headers: headers})
            .pipe(map(res => res));
    }

    // getApiExecutorsByPartnerAccount(partner, account) {
    //     this.getHttp();
    //     switch (partner) {
    //         case 'samples':
    //             return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', this.samplesOptions)
    //                 .pipe(map(res => res));
    //             break;
    //         default :
    //             return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', this.httpOptions)
    //                 .pipe(map(res => res));
    //             break;
    //     }
    // }

    getApiExecutorsByPartnerAccount(partner, account, params) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'API-PLATFORM-PARTNER-KEY': localStorage.getItem('partnerKey'),
            'API-PLATFORM-PARTNER': partner,
            'observe': 'response'
        });

        let url = environment.serviceshost + '/v1/authorizeAndGetApiExecutors';

        if (params && params !== '') {
            url = url + '?' + params;
        }

        return this._http.get(url, {headers: headers})
            .pipe(map(res => res));
    }

    // getApiExecutorsByPartnerAccountType(partner, account, type) {
    //     this.getHttp();
    //     if (partner === 'services') {
    //         return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors/type/' + type, this.servicesOptions)
    //             .pipe(map(res => res));
    //     } else {
    //         return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors/type/' + type, this.httpOptions)
    //             .pipe(map(res => res));
    //     }
    // }

    getApiExecutorsByPartnerAccountType(partner, account, type, params = 'type=' + type + '&partner=' + partner + '&account=' + account + '&fields=partner,account_id,executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description,pathParams,queryParams,headers,authModel,requestBody,responseAttributes') {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'API-PLATFORM-PARTNER-KEY': localStorage.getItem('partnerKey'),
            'API-PLATFORM-PARTNER': partner,
            'observe': 'response'
        });

        let url = environment.serviceshost + '/v1/authorizeAndGetApiExecutors';

        if (params && params !== '') {
            url = url + '?' + params;
        }

        return this._http.get(url, {headers: headers})
            .pipe(map(res => res));
    }

    insertApiExecutorForPartnerAccount(partner, account, doc) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    insertApiExecutorForPartner(partner, account, pkey, doc) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.post(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    executeSql(doc) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/sql/executor', doc, this.httpOptions)
            .pipe(map(res => res));
    }

    updateApiExecutorForPartnerAccount(partner, account, id, doc) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.put(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors/' + id, doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    updateApiExecutorForPartnerAccountWithPkey(partner, account, pkey, id, doc) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.put(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors/' + id, doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    createEmailTemplate(partner, account, payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + account + '/emailTemplate', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    getBillingData(data) {
        // const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + data.partner + '/invoice/' + data.year + '/' + data.month, {
            headers: this.adminPKeyHeader,
            observe: 'response'
        })
            // .timeoutWith(30000, Observable.throw(new Error('Timeout Exceeded')))
            .pipe(map(res => res));
    }

    getEntityNameAndVersionAsCustomTypeWithParams(partner, account, databaseName) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entitiesascustomtypes?database=' + databaseName, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    getEntityNameAndVersionAsCustomType(partner, account) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entitiesascustomtypes', {
            headers: headers,
            observe: 'response'
        })
            .timeoutWith(60000, Observable.throw(new Error('Timeout Exceeded')))
            .pipe(map(res => res));
    }


    // getBillingData(data) {
    //     this.getHttp();
    //     return this._http.get(environment.apihost + '/v1/admin/' + data.partner + '/invoice/' + data.year + '/' + data.month, this.httpOptionsWithObserveResponse)
    //         .timeoutWith(30000, Observable.throw(new Error('Timeout Exceeded')))
    //     .pipe(map(res => res));
    // }

    getBillingSpan(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/billspan', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getCoupons(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/coupons', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    applyCoupon(invoiceID, couponID) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + invoiceID + '/add/coupon/' + couponID, {
            headers: this.adminPKeyHeader,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    getExecutorsForBlocks(partner, account, doc) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/api/getexecutors', doc, this.httpOptions)
            .pipe(map(res => res));
    }

    deleteApiExecutorsByPartnerAccountEntityVersion(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.delete(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version + '/executors', {headers: headers})
            .pipe(map(res => res));
    }

    deleteApplication(id) {
        this.getHttp();
        return this._http.delete(environment.serviceshost + '/v1/application/' + id, this.servicesOptions)
            .pipe(map(res => res));
    }

    deleteApiExecutorByPartnerAccountByNameAndVersion(partner, account, pkey, entity, version) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': pkey,
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        return this._http.delete(environment.apihost + '/v1/api/' + partner + '/' + account + '/' + entity + '/' + version, {headers: headers})
            .pipe(map(res => res));
    }

    // Database to API Transformation
    getTablesFromDatabaseForPartner(partnerId, databaseName) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partnerId + '/' + databaseName + '/schema', this.httpOptions)
            .pipe(map(res => res));
    }

    getDatabaseObjectsFromDatabaseForPartner(partnerId, databaseName, doc) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + databaseName + '/schema', doc, this.httpOptions)
            .pipe(map(res => res));
    }

    getAllDatabaseObjectsFromDatabaseForPartner(partnerId, databaseName, doc) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + databaseName + '/schema/all', doc, this.httpOptions)
            .pipe(map(res => res));
    }

    buildDeploymentPlanForDatabaseTransformation(partnerId, accountId, doc) {
        const headers = new HttpHeaders({
            'pkey': localStorage.getItem('partnerKey'),
        });
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/deploymentplan', doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    buildDeploymentPlanForOpenApi(partnerId, accountId, yaml, version) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/deploymentplanfromyaml?openAPIVersion=' + version, yaml, this.httpOptions)
            .pipe(map(res => res));
    }

    buildDeploymentPlanForPostmanCollection(partnerId, accountId, collection, collectionVersion, apiVersion, importAs, serviceProvider, registerAsIs) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/api-creators/postman-collection/deployment-plan?postmanCollectionVersion=' + collectionVersion + '&apiVersion=' + apiVersion + '&importAs=' + importAs + '&serviceProvider=' + serviceProvider + '&registerAsIs=' + registerAsIs, collection, this.httpOptions)
            .pipe(map(res => res));
    }

    createApiFromDeploymentPlanForPartnerAccount(partnerId, accountId, doc) {
        const headers = new HttpHeaders({
            'pkey': localStorage.getItem('partnerKey'),
        });
        return this._http.post(environment.apihost + '/v1/admin/' + partnerId + '/' + accountId + '/createfromdeploymentplan', doc, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    // Authn
    validateAuth(data) {
        return this._http.post(environment.iamhost + '/v1/validate', data, this.httpOptions)
            .pipe(map(res => res));
    }

    getResponseAttribute(partner, account, doc) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account + '/getresponseattributes', doc, this.httpOptions)
            .pipe(map(res => res));
    }

    insertEmailEvent(partner, account, version, entity, item) {
        this.getHttp();
        return this._http.post(environment.campaignHost + '/v1/emailActionLogger', item, this.campaignOptions)
            .pipe(map(res => res));
    }

    getAttributeSchemaofJSONString(partner, account, jsonString) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account + '/get-attributes-schema', jsonString, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    insertAttributeToPartnerAccount(attribute, partner, payload) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/manage/partner-configurations', payload, {
            headers: headers,
            observe: 'response',
            params: {'partnerId': partner, 'attribute': attribute}
        })
            .pipe(map(res => res));
    }

    updateSpecificAttributeOfPartnerAccount(attribute, partner, payload, attributeIdentifier) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.put(environment.apihost + '/v1/admin/manage/partner-configurations', payload, {
            headers: headers,
            observe: 'response',
            params: {'partnerId': partner, 'attribute': attribute, 'attributeIdentifier': attributeIdentifier}
        })
            .pipe(map(res => res));
    }

    deleteSpecificAttributeOfPartnerAccount(attribute, attributeIdentifier, partner) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.delete(environment.apihost + '/v1/admin/manage/partner-configurations', {
            headers: headers,
            observe: 'response',
            params: {'partnerId': partner, 'attribute': attribute, 'attributeIdentifier': attributeIdentifier}
        })
            .pipe(map(res => res));
    }

    getAllIPGroups(partner) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/ip-groups', {
            headers: headers,
            observe: 'response'
        });
    }

    getAttributeSchemaForPartnerAttribute(attribute, partner) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/manage/partner-configurations/attribute-schema', {
            headers: headers,
            observe: 'response',
            params: {'partnerId': partner, 'attribute': attribute}
        });
    }

    generatePayloadFromAttributes(account, partner, payload) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/' + account + '/generate-payload-from-attributes', payload, {
            headers: headers,
            observe: 'response'
        });
    }

    getSettingsCRUD(partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/services/services/settings?partner=' + partner + '&account=' + account, this.servicesOptions);
    }


    getDataFromServiceForPartnerAccount(entity, partner, account) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/services/services/' + entity + '?partner=' + partner + '&account=' + account, this.servicesOptions);
    }

    getArchivedPartners() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/partners-archive', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getArchivedPartnerByName(partner) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/partners-archive/' + partner, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    deleteArchivedPartnerByName(partner) {
        this.getHttp();
        return this._http.delete(environment.apihost + '/v1/admin/partners-archive/' + partner, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    addToArchivePartner(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/partners-archive', payload, this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getSettingsCRUDwithParam(partner, account, params) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/data/services/services/settings?partner=' + partner + '&account=' + account + '?' + params, this.servicesOptions);
    }

    getGenericCall(url, headers) {
        return this._http.get(url, headers)
            .pipe(map(res => res));
    }

    postGenericCall(url, headers, payload) {
        return this._http.post(url, payload, headers)
            .pipe(map(res => res));
    }

    deleteGenericCall(url, headers) {
        return this._http.delete(url, headers)
            .pipe(map(res => res));
    }

    patchGenericCall(url, payload, headers) {
        return this._http.patch(url, payload, headers)
            .pipe(map(res => res));
    }

    getJSONschemaforEntity(partner, account, entity, version) {
        if (partner === 'services') {
            return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/' + entity + '/' + version + '/jsonschema', this.servicesOptions)
                .pipe(map(res => res));
        }
    }

    authRequest(endpoint) {
        const headers = new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(endpoint, {headers: headers, observe: 'response'})
            .pipe(map(res => res));
    }

    getConnectorAccessToken(pkey, redirect_uri, code, state, index, service, status) {
        const headers = new HttpHeaders({
            pkey: pkey,
            redirect_uri: redirect_uri,
            code: code,
            state: state,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.pythonServicesServer + '/v1/' + localStorage.getItem('partner') + '/' + localStorage.getItem('account') + '/' + service + '/callback?index=' + index + '&status=' + status, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    deleteConnectorConnection(pkey, index, service) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.delete(environment.pythonServicesServer + '/v1/' + localStorage.getItem('partner') + '/' + localStorage.getItem('account') + '/' + service + '/delete-config?index=' + index, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    testConnectorConnection(pkey, index, service) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.pythonServicesServer + '/v1/' + localStorage.getItem('partner') + '/' + localStorage.getItem('account') + '/' + service + '/token-validity?index=' + index, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    createSecretInAWSSecretsManager(pkey, partner, account, payload) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.pythonServicesServer + '/v1/aws-secrets-manager/create-secret?partner=' + partner + '&account=' + account, payload, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    createUserInHashicorpVault(pkey, partner, account) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.pythonServicesServer + '/v1/havault-manager/create-user?partner=' + partner + '&account=' + account, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    createSecretInHashicorpVault(pkey, partner, account, payload) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.pythonServicesServer + '/v1/havault-manager/create-secret?partner=' + partner + '&account=' + account, payload, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    enableEnvironment(payload) {
        return this._http.post(environment.pythonServicesServer + '/v1/admin/infra/enable', payload, {observe: 'response'})
            .pipe(map(res => res));
    }

    createEnvironment(payload) {
        return this._http.post(environment.pythonServicesServer + '/v1/admin/infra/create', payload, {observe: 'response'})
            .pipe(map(res => res));
    }

    dnsValidation(payload) {
        return this._http.post(environment.pythonServicesServer + '/v1/admin/infra/dnsvalidation', payload, {observe: 'response'})
            .pipe(map(res => res));
    }

    pingURL(url) {
        return this._http.get(url, {observe: 'response'})
            .pipe(map(res => res));
    }

    getDataWithQuery(partner, account, version, entity, query) {
        this.getHttp();
        if (partner === 'services') {
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?' + query, this.servicesOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?' + query, this.httpOptions)
                .pipe(map(res => res));
        }
    }

    getData(partner, account, version, entity, queryParams) {
        let apiURL = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity;
        if (queryParams) {
            apiURL = apiURL + '?' + queryParams;
        }
        this.getHttp();
        switch (partner) {
            case 'services' :
                return this._http.get(apiURL, this.servicesOptions)
                    .pipe(map(res => res));
            case 'access' :
                return this._http.get(apiURL, this.accessOptions)
                    .pipe(map(res => res));
            case 'dev-access':
                return this._http.get(apiURL, this.devAccessOptions)
                    .pipe(map(res => res));
            case 'campaign' :
                return this._http.get(apiURL, this.campaignOptions)
                    .pipe(map(res => res));
            default :
                return this._http.get(apiURL, this.httpOptions)
                    .pipe(map(res => res));
        }
    }

    addServiceProviderCategory(payload) {
        this.getHttp();
        // return this._http.post( environment.serviceshost + '/v1/producerCategories', payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.post(environment.apihost + '/v1/data/services/services/producerCategories', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    patchItemServices(version, entity, payload, id) {
        // return this._http.patch( environment.serviceshost + '/' + version + '/' + entity + '/' + id, payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.patch(environment.apihost + '/' + version + '/data/services/services/' + entity + '/' + id, payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    addItemServices(version, entity, payload) {
        // return this._http.post( environment.serviceshost + '/' + version + '/' + entity, payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.post(environment.apihost + '/' + version + '/data/services/services/' + entity, payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    addItemServices1(version, entity, payload) {
        // return this._http.post('https://gateway.services.apiplatform.io/' + version + '/' + entity, payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.post(environment.apihost + '/' + version + '/data/services/services/' + entity, payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    patchProviderCategory(payload, id) {
        this.getHttp();
        // return this._http.patch(environment.serviceshost + '/v1/producerCategories/' +  id, payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.patch(environment.apihost + '/v1/data/services/services/producerCategories/' + id, payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    addProviderCategory(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/data/services/services/producerCategories', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    // addServiceProvider(payload) {
    //     this.getHttp();
    //     // return this._http.post(environment.serviceshost + '/v1/addServiceProvider', payload, this.servicesOptions)
    //     //     .pipe(map(res => res));
    //     return this._http.post(environment.apihost + '/services/services/v1/addServiceProvider', payload, this.servicesOptions)
    //         .pipe(map(res => res));
    // }
    getBusinessLogicApisByCategory(partner, account) {
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/category/businesslogicapis', this.servicesOptions)
            .pipe(map(res => res));
    }

    getApiExecutorForPartnerAccount(partner, account) {
        const headers = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        if (partner === 'services') {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', this.servicesOptions)
                .pipe(map(res => res));
        } else {
            return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', {headers: headers})
                .pipe(map(res => res));
        }
    }

    executeEmail(payload) {
        this.getHttp();
        return this._http.post(environment.campaignHost + '/v1/emailExecutor', payload, this.campaignOptions)
            .pipe(map(res => res));
    }

    generatePartnerKey(partner, account, pkey) {
        // this.getHttp();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'API-PLATFORM-PARTNER': partner,
                'API-PLATFORM-ACCOUNT': account,
                'API-PLATFORM-PARTNER-KEY': pkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        return this._http.get(environment.apihost + '/v1/token', httpOptions)
            .pipe(map(res => res));
    }

    getDeploymentPlanForCOBOL(partner, account, payload, apikey, transformOption) {
        const formData = new FormData();
        // formData.append('file', payload);


        formData.append('file', new Blob([payload], {
            type: 'text/x-cobol'
        }));
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': localStorage.getItem('partnerKey'),
                'apikey': apikey,
                'Access-Control-Allow-Origin': '*'
            }),
        };

        return this._http.post(environment.pythonServicesServer + '/v1/' + partner + '/' + account + '/cobol-plan?transformOption=' + transformOption, formData, {headers: httpOptions.headers})
            .pipe(map(res => res));
    }

    getBulkSecrets(partner, account, providerName, title) {
        const headers = new HttpHeaders({
            pkey: localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.pythonServicesServer + '/v1/secrets/bulk-get-secrets?partner=' + partner + '&account=' + account + '&title=' + title + '&providerName=' + providerName, {headers: headers})
            .pipe(map(res => res));

    }

    getCountforSecrets(partner, account, pkey) {
        const headers = new HttpHeaders({
            pkey: pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.pythonServicesServer + '/v1/secrets/get-count?partner=' + partner + '&account=' + account, {headers: headers})
            .pipe(map(res => res));

    }

    insertSecret(partner, account, title, payload) {
        const headers = new HttpHeaders({
            pkey: localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.pythonServicesServer + '/v1/secrets/insert-secret?partner=' + partner + '&account=' + account + '&title=' + title, payload, {headers: headers})
            .pipe(map(res => res));
    }

    deleteSecrets(partner, account, title, provider, name) {
        const headers = new HttpHeaders({
            pkey: localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.delete(environment.pythonServicesServer + '/v1/secrets/delete-secret?partner=' + partner + '&account=' + account + '&title=' + title + '&providerName=' + provider + '&name=' + name, {headers: headers})
            .pipe(map(res => res));
    }

    getTablesListWithPrimaryKeysForADatabaseConnection(partner, databaseType, databaseConnectionName, pkey) {
        const headers = new HttpHeaders({
            'pkey': pkey
        });
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + databaseConnectionName + '/primary-keys', {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    addOrDeleteForeignKeyConstraints(partner, databaseType, databaseConnectionName, tableName, pkey, payload) {
        const headers = new HttpHeaders({
            'pkey': pkey
        });
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + databaseConnectionName + '/' + tableName + '/referential-keys', payload, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    testEmailServerConfigurations(pkey, payload) {
        const headers = new HttpHeaders({
            'pkey': pkey
        });
        return this._http.post(environment.apihost + '/v1/admin/email-server-configuration/test', payload, {
            headers: headers,
            observe: 'response'
        })
            .pipe(map(res => res));
    }

    pauseJob(partner, account, pkey, apikey, jobId) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.get(environment.schedulerServer + '/v1/' + partner + '/' + account + '/scheduler/jobs/' + jobId + '/pause', {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    resumeJob(partner, account, pkey, apikey, jobId) {
        const headers = new HttpHeaders({
            'pkey': pkey
        });
        return this._http.get(environment.schedulerServer + '/v1/' + partner + '/' + account + '/scheduler/jobs/' + jobId + '/resume', {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    deleteJob(partner, account, pkey, apikey, jobId) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.delete(environment.schedulerServer + '/v1/' + partner + '/' + account + '/scheduler/jobs/' + jobId, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    rescheduleJob(partner, account, pkey, apikey, jobId, payload) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.put(environment.schedulerServer + '/v1/' + partner + '/' + account + '/scheduler/jobs/' + jobId + '/reschedule', payload, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    scheduleJob(partner, account, pkey, apikey, payload) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.post(environment.schedulerServer + '/v1/' + partner + '/' + account + '/scheduler/jobs/schedule', payload, {
            observe: 'response',
            headers: headers
        })
            .pipe(map(res => res));
    }

    getTimeZones() {
        const headers = new HttpHeaders({
            pkey: '3fe18f9884ea832e3fede1e661740c4a'
        });
        return this._http.get(environment.apihost + '/v2/data/commons/commons/timezones', {headers})
            .pipe(map(res => res));
    }

    getPropertiesOfTable(partner, databaseType, databaseConnectionName, databaseName, tableName) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + databaseConnectionName + '/' + databaseName + '/' + tableName + '/properties', this.httpOptions)
            .pipe(map(res => res));
    }

    getDataOfADatabaseTable(partner, databaseType, databaseConnectionName, databaseName, tableName, limit, offset) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + databaseConnectionName + '/' + databaseName + '/' + tableName + '/data?limit=' + limit + '&offset=' + offset, this.httpOptions)
            .pipe(map(res => res));
    }

    getDatabasesForAConnection(partner, database, databaseType) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + database + '/list-databases', this.httpOptions)
            .pipe(map(res => res));
    }

    getDatabaseTablesForAConnection(partner, databaseConnectionName, databaseType, databaseName) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/database/' + databaseType + '/' + databaseConnectionName + '/get-database-tables?database=' + databaseName, this.httpOptions)
            .pipe(map(res => res));
    }


    getEntireSchemaForPartnerDatabaseTable(partner, payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/database/table/schema', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    getEntireSchemaForPartnerDatabase(partner, payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/admin/' + partner + '/database/schema', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    getPartnerAPISummary() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/partners/apis/summary', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    postUserRegistrationDetails(payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/platformUserRegistration', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    getAllPartners() {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/partners', this.adminHttpOptions)
            .pipe(map(res => res));
    }

    getAllExecutorsOfPartner(partner, account, pkey) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/executors', {headers: headers})
            .pipe(map(res => res));
    }

    forgotEnvironment(payload) {
        this.getHttp();
        return this._http.post(environment.accessHost + '/v1/forgotPartner', payload, this.accessOptions)
            .pipe(map(res => res));
    }

    // getPubSubMessages(query) {
    //     this.getHttp();
    //     return this._http.get(environment.serviceshost + '/v1/pubSubMessages?headers.lookupDestination=' + query, this.servicesOptions)
    //         .pipe(share(), map(res => res));
    //
    // }

    getDependenciesForEntities(partner, account, entityName, entityVersion, targetPartner, targetAccount) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entity/' + entityName + '/' + entityVersion + '/dependencies?targetPartner=' + targetPartner + '&targetAccount=' + targetAccount, this.httpOptions)
            .pipe(map(res => res));
    }

    getDependenciesForExecutors(partner, account, executorName, executorVersion, targetPartner, targetAccount) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/business-logic/' + executorName + '/' + executorVersion + '/dependencies?targetPartner=' + targetPartner + '&targetAccount=' + targetAccount, this.httpOptions)
            .pipe(map(res => res));
    }

    getPubSubMessages(query) {
        this.getHttp();
        return this._http.get(environment.kingerHost + '/v1/data/messages-log?entityName=pubSubMessageLogs&entityVersion=v1&topic=' + query, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        })
            .pipe(share(), map(res => res));

    }

    postPubSubMessage(partner, account, pkey, topic, message) {
        const headers = new HttpHeaders({
            pkey: pkey
        });
        return this._http.post(environment.kingerHost + '/v1/' + partner + '/' + account + '/' + topic + '/message/publish', message, {headers: headers})
            .pipe(map(res => res));

    }

    getNoOfAPIsAndUsers() {
        this.getHttp();
        return this._http.get(environment.monitoringhost + '/v1/getRealTimeInfo', this.monitoringOptions)
            .pipe(map(res => res));
    }

    getPartnerAccountEntityGateway(partner, account, pKey, entityName, entityVersion) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': pKey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entity/' + entityName + '/' + entityVersion + '/gateway', httpOptions)
            .pipe(map(res => res));
    }

    getUsagesForEntity(partner, account, entityName, entityVersion) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/entity/' + entityName + '/' + entityVersion + '/usages', this.httpOptions)
            .pipe(map(res => res));
    }

    getUsagesForAPI(partner, account, executorName, executorVersion) {
        this.getHttp();
        return this._http.get(environment.apihost + '/v1/admin/' + partner + '/' + account + '/api/' + executorName + '/' + executorVersion + '/usages', this.httpOptions)
            .pipe(map(res => res));
    }

    getFileFromS3(url) {
        this.getHttp();
        return this._http.get(url, this.httpOptions)
            .pipe(map(res => res));
    }

    getFilesFromS3(partner, payload) {
        this.getHttp();
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': localStorage.getItem('partnerKey'),
            'Access-Control-Allow-Origin': '*',
            'observe': 'response'
        });
        /*return this._http.get(environment.apihost + '/v1/data/' + partner + '/' +partner + '/s3connectors/' + partner + '.apiplatform.io' + '/list-files', this.httpOptions)
            .pipe(map(res => res));*/
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + partner + '/s3connectors/' + partner + '.apiplatform.io' + '/get-files', payload, this.httpOptions)
            .pipe(map(res => res));
    }

    insertEntityWithAPI(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/masterCreateExecutor', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    upsertAPIWithCore(partner, account, pkey, payload, isEntity: boolean, isUpdate: boolean, engagement: boolean, pubSubEngagement: boolean) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        if (payload) {
            payload['servers'] = {
                services: environment.apihostname,
                kinger: environment.kingerHostName,
                kong: environment.adminGatewayHost,
                'python-services': environment.pythonServerHostName
            };
        }
        return this._http.post(environment.apihost + '/core/core/v2/upsert-api?isEntity=' + isEntity + '&update=' + isUpdate + '&pubSubEngagement=' + pubSubEngagement + '&engagement=' + engagement, payload, {headers: headers})
            .pipe(map(res => res));
    }

    generateBlockForSAIL(partner, pkey, sailCode) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'observe': 'response',
            'pkey': pkey
        });
        const payload = {
            sail_code: sailCode,
            method: 'sail+chatgpt'
        };
        return this._http.post(environment.pythonServicesServer + `/v1/block/${partner}/generate/sail`, payload, {headers: headers})
            .pipe(map(res => res));

    }

    promoteAPIWithCore(partner, account, pkey, payload, override: boolean, engagement: boolean, pubSubEngagement: boolean) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        if (payload) {
            payload['servers'] = {
                services: environment.apihostname,
                kinger: environment.kingerHostName,
                kong: environment.adminGatewayHost,
                'python-services': environment.pythonServerHostName
            };
        }
        return this._http.post(environment.apihost + '/core/core/v1/promote-api?override=' + override + '&pubSubEngagement=' + pubSubEngagement + '&engagement=' + engagement, payload, {headers: headers})
            .pipe(map(res => res));
    }

    postDevexConsumerEntitiesWithFormAttributes(partner, account, pkey, payload) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        if (payload) {
            payload['servers'] = {
                services: environment.apihostname,
                kinger: environment.kingerHostName,
                kong: environment.adminGatewayHost,
                'python-services': environment.pythonServerHostName
            };
        }
        return this._http.post(environment.apihost + '/core/core/v1/create-devex-consumer-entity', payload, {headers: headers})
            .pipe(map(res => res));
    }

    getCoreApi(apiName, apiVersion, query) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'observe': 'response'
        });
        return this._http.get(environment.apihost + '/core/core/' + apiVersion + '/' + apiName + (query ? ('?' + query) : ''),
            {headers: headers})
            .pipe(map(res => res));
    }

    postCoreApi(apiName, apiVersion, payload, partnerDetails = {partnerKey: localStorage.getItem('partnerKey')}) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.corePkey,
            'apikey': environment.coreAPIKey,
            'API-PLATFORM-PARTNER-KEY': partnerDetails.partnerKey,
            'observe': 'response'
        });
        if (payload) {
            payload['servers'] = {
                services: environment.apihostname,
                kinger: environment.kingerHostName,
                kong: environment.adminGatewayHost,
                'python-services': environment.pythonServerHostName
            };
        }
        return this._http.post(environment.apihost + '/core/core/' + apiVersion + '/' + apiName, payload, {headers: headers})
            .pipe(map(res => res));
    }

    postIntegrationsApi(apiName, apiVersion, payload) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': environment.integrationsPkey,
            'apikey': environment.integrationsAPIKey,
            'observe': 'response'
        });
        if (payload) {
            payload['servers'] = {
                services: environment.apihostname,
                kinger: environment.kingerHostName,
                kong: environment.adminGatewayHost,
                'python-services': environment.pythonServerHostName
            };
        }
        return this._http.post(environment.apihost + '/integrations/integrations/' + apiVersion + '/' + apiName, payload, {headers: headers})
            .pipe(map(res => res));
    }

    promoteAPI(partner, account, pkey, targetPartner, targetAccount, targetPkey, apiType, override, payload) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
            'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
            'API-PLATFORM-PARTNER-KEY': pkey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'observe': 'response'
        });
        return this._http.post(environment.serviceshost + '/v1/promote-api?target-partner=' + targetPartner + '&target-account=' + targetAccount + '&target-pkey=' + targetPkey + '&api-type=' + apiType + '&override=' + override, payload, {headers: headers})
            .pipe(map(res => res));
    }

    insertExecutorWithAPI(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/masterCreateExecutor', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    postDevexConsumerEntitiesWithFormAttributes1(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/createDevexConsumerEntity', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    manageJenkinsJob(action, jobName, payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/jenkins-manage-job?action=' + action + '&jobName=' + jobName, payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    getJenkinsBuildConsole(jobName, buildNumber) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.autServicesPkey,
            'apikey': environment.autServicesAPIKey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.autServiceshost + '/v1/get-build-console?job-name=' + jobName + '&build-number=' + buildNumber, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    deleteJenkinsJob(partner, partnerKey, apiName, apiVersion) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.autServicesPkey,
            'apikey': environment.autServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-PARTNER-KEY': partnerKey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.delete(environment.autServiceshost + '/v1/delete-external-testsuite-job?api-name=' + apiName + '&api-version=' + apiVersion, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    uploadSSLFile(account, partner, fileType, File) {
        // console.log('upload file api called...');
        this.getHttp();
        const formData = new FormData();
        formData.append('multipartFile', File);
        formData.append('account', account);
        formData.append('partner', partner);
        formData.append('fileType', fileType);
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/uploadSSLFile', formData, httpOptions)
            .pipe(map(res => res));

    }

    removeSSLFile(account, partner, fileName, filePath) {
        const payload = {
            'account': account,
            'partner': partner,
            'file_name': fileName,
            'file_path': filePath
        };
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/removeSSLFile', payload, httpOptions)
            .pipe(map(res => res));
    }

    ConfigureSSL(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/getAuthTokenUsingSSL', payload, httpOptions)
            .pipe(map(res => res));
    }

    getSSLFilesPath(account, partner) {
        // console.log('get SSL files method called...')
        const payload = {
            'account': account,
            'partner': partner
        };
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/getSSLFilesPath', payload, httpOptions)
            .pipe(map(res => res));
    }

    getAPIUsagesWithTestsuites(partner, account, pkey, executor_name, executor_version) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.apiServiceshost + '/v1/api-usages-with-testsuites?executor_name=' + executor_name + '&executor_version=' + executor_version, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    getEntityUsagesWithTestsuites(partner, account, pkey, entity, version) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.apiServiceshost + '/v1/entity-usages-with-testsuites?entity_name=' + entity + '&entity_version=' + version, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    getAPITestSuiteResult(partner, account, pkey, executor_name, executor_version) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/execute-api-usage-testsuites', {
            executor_name: executor_name,
            executor_version: executor_version
        }, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    getEntityTestSuiteResult(partner, account, pkey, entity, version) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/execute-entity-usage-testsuites', {
            entity: entity,
            version: version
        }, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    getAPITestsuites(partner, account, pkey, executor_name, executor_version, edit) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.apiServiceshost + '/v1/api-testsuite?executor_name=' + executor_name + '&executor_version=' + executor_version + '&edit=' + edit, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    getAPITestsuiteCallLogs(partner, account, pkey, query) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.get(environment.apiServiceshost + '/v1/api-testsuite-log?' + query, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    updateAPITestsuites(partner, account, pkey, payload) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/upsert-api-testsuite', payload, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    runAPITestsuites(partner, account, pkey, payload) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/test-api-testsuite', payload, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    testAPITestsuiteWithUsages(partner, account, pkey, payload) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/test-api-usage-testsuites', payload, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    testEntityTestsuiteWithUsages(partner, account, pkey, payload) {
        const servicesOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            'pkey': environment.apiServicesPkey,
            'apikey': environment.apiServicesAPIKey,
            'API-PLATFORM-PARTNER': partner,
            'API-PLATFORM-ACCOUNT': account,
            'API-PLATFORM-PARTNER-KEY': pkey,
            'Access-Control-Allow-Origin': '*'
        });
        return this._http.post(environment.apiServiceshost + '/v1/test-entity-usage-testsuites', payload, {headers: servicesOptions})
            .pipe(map(res => res));
    }

    createGitRepo(token, payload) {
        let authToken = 'Bearer ' + token;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': authToken,
        });

        return this._http.post('https://api.github.com/user/repos', payload, {headers: headers})
            .pipe(map(res => res));
    }

    getGitUser(token) {
        let authToken = 'Bearer ' + token;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': authToken,
        });

        return this._http.get('https://api.github.com/user', {headers: headers})
            .pipe(map(res => res));
    }

    getGitUserRepo(token) {
        let authToken = 'Bearer ' + token;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': authToken,
        });

        return this._http.get('https://api.github.com/user/repos', {headers: headers})
            .pipe(map(res => res));
    }

    getGitUserBranch(token, user, repo) {
        let authToken = 'Bearer ' + token;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': authToken,
        });

        const url = 'https://api.github.com/repos/' + user + '/' + repo + '/branches';
        return this._http.get(url, {headers: headers})
            .pipe(map(res => res));
    }

    commitToGitHub(account, token, branch, repo_path, file_path, filename, code, message) {
        const payload = {
            'message': message,
            'branch': branch,
            'committer': {'name': account, 'email': localStorage.getItem('signInEmail')},
            'content': code
        };
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }),

        };

        const url = 'https://api.github.com/repos/' + repo_path + '/contents/' + file_path;
        return this._http.put(url, payload, httpOptions)
            .pipe(map(res => res));
    }

    mergeToGitHub(account, token, branch, repo_path, file_path, filename, code, sha, message) {
        const payload = {
            'message': message,
            'branch': branch,
            'committer': {'name': account, 'email': localStorage.getItem('signInEmail')},
            'content': code,
            'sha': sha
        };
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }),

        };

        const url = 'https://api.github.com/repos/' + repo_path + '/contents/' + file_path;
        return this._http.put(url, payload, httpOptions)
            .pipe(map(res => res));
    }

    getCollectionDataFromLink(link) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this._http.get(link, {headers: headers})
            .pipe(map(res => res));
    }

    deleteItemServices(version, entity, id) {
        // return this._http.post( environment.serviceshost + '/' + version + '/' + entity, payload, this.servicesOptions)
        //     .pipe(map(res => res));
        return this._http.delete(environment.apihost + '/' + version + '/data/services/services/' + entity + '/' + id, this.servicesOptions)
            .pipe(map(res => res));
    }

    getAttributeForUnifiedQueryAPI(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/getAttributeForUnifiedQueryAPI', payload, httpOptions)
            .pipe(map(res => res));
    }

    executeUnifiedQueryAPI(payload) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            })
        };
        return this._http.post(environment.pythonServicesServer + '/v1/admin/executeUnifiedQueryAPI', payload, httpOptions)
            .pipe(map(res => res));
    }

    getEmbeddedGraph(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/generateDatadogEmbed', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    getRequestCountfromDatadog(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/getTotalRequestCountFromDataDog', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    getAverageLatencyfromDatadog(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/getAverageLatencyFromDataDog', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    getInvoiceByEmail(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/getInvoicesByEmailId', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    applyCredit(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/checkAndApplyCredit', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getCreditsForPartner(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/getCreditsForPartner', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    updateInvoiceStatus(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/updateInvoiceStatus', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    validateBillingStatus(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/validate-billing-status', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    createStripePaymentLink(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/stripe-checkout-session', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getPaymentHistoryForPartner(payload) {
        this.getHttp();
        return this._http.post(environment.serviceshost + '/v1/getPaymentHistory', payload, this.servicesOptions)
            .pipe(map(res => res));
    }

    getTextEmbeddingGecko() {
        this.getHttp();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fdabdac7be3f1483fd675c4334d4a72',
                'apikey': 'a9WnwaZF0rrMy2T7iUcAnM9cEyTc7jTy',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        const url = 'https://dev-rohanmurali.gateway.apiplatform.io/v1/TextEmbeddingGecko';
        return this._http.get(url, options)
            .pipe(map(res => res));
    }

    getEnterprisePlans(payload) {
        this.getHttp();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fbbb8bc5a969f503fdb66e7d90509d6',
                'apikey': '7xR2sYhqRAdfhhyu6jMo9E9hi4fRazuw',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        const url = 'https://dev-vikram.gateway.apiplatform.io/v1/Product?account=' + payload['account'] + '&partner=' + payload['partner'];
        return this._http.get(url, options)
            .pipe(map(res => res));
    }

    postEnterprisePlans(payload) {
        this.getHttp();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fbbb8bc5a969f503fdb66e7d90509d6',
                'apikey': '7xR2sYhqRAdfhhyu6jMo9E9hi4fRazuw',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        const url = 'https://dev-vikram.gateway.apiplatform.io/v1/Product';
        return this._http.post(url, payload, options)
            .pipe(map(res => res));
    }

    invokeWorkflow(payload) {
        this.getHttp();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fbbb8bc5a969f503fdb66e7d90509d6',
                'apikey': '7xR2sYhqRAdfhhyu6jMo9E9hi4fRazuw',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        const url = 'https://dev-vikram.gateway.apiplatform.io/v1/startBPMN';
        return this._http.post(url, payload, options)
            .pipe(map(res => res));
    }

    searchText(payload) {
        this.getHttp();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fdf8f9eb64b4a0c3fd1ea46bc60a10e',
                'apikey': 'VYlmLgQXILD3VMJhAyUE2WL9I43vZXrO',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        const url = 'https://dev-userishwariya.gateway.apiplatform.io/v2/searchText';
        return this._http.post(url, payload, options)
            .pipe(map(res => res));
    }

    getDataAnalyticsPlans(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/get-data-analytics-plans', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    postDataAnalyticsPlan(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/add-data-analytics-plan', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataTransformationPlans(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/get-data-transform-plans', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataTransformationPlanForPartner(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/get-data-transform-plan-for-partner', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    postDataTransformationPlan(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/add-data-transform-plan', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    deleteDataTransformationPlan(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/delete-data-transform-plan', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getDashboChartId(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/get-dashbo-chart-id', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    transformData(payload) {
        this.getHttp();
        return this._http.post('https://transformer.haiva.ai/v1/data-transformation', payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataTransformationPlanDetails(id: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-transformation-plan-details?transformationPlanId=' + id;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    retryDataTransformation(payload: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/retry-data-transformation-record';
        return this._http.post(url, payload, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataTransformationByPlanId(id: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-transformations-by-transformationPlanId?transformationPlanId=' + id;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataMigrationByTransformationPlanId(id: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-migrations-by-transformationPlanId?transformationPlanId=' + id;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataBatchesByTransformationPlanId(id: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-batches-by-transformationPlanId?transformationPlanId=' + id;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getDataRecordsByBatchId(id: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-records-by-batch?batchId=' + id;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getTransformationHistory(email: any, partner: any, partnerKey: any) {
        this.getHttp();
        const url = environment.coreHost + '/v1/get-transformation-history?executedBy=' + email + '&partnerKey=' +
            partnerKey + '&partner=' + partner;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getMigrationById(email: any, migrationId: any) {
        this.getHttp();
        const url = environment.coreHost + 'v1/get-migrations-by-user-migration?executedBy=' + email + '&migrationId=' + migrationId;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    getTranformDataWorkflowDetails(workflowRunId) {
        this.getHttp();
        const url = environment.coreHost + '/v1/workflowRun?workflowRunId=' + workflowRunId;
        return this._http.get(url, this.coreOptions)
            .pipe(map(res => res));
    }

    uploadToS3(file: File) {
        const formData = new FormData();
        formData.append('multipartFile', file);
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': '3fe0995209f5abcd3fe237286f32afa5',
            })
        };
        const url = 'https://services.apiplatform.io/v1/data/hari/hari/uploadfiletopartneraccount?folder=saasgenie';
        return this._http.post(url, formData, httpOptions)
            .pipe(map(res => res));
    }

    getDataTransformationHistory(payload) {
        this.getHttp();
        return this._http.post(environment.coreHost + '/v1/get-data-transformation-history', payload, this.coreOptions)
            .pipe(map(res => res));
    }
}
